import { cn } from '@/lib/utils'
import { workspaceMonogram } from './account'

/**
 * The business's mark in the app frame: its initials on a neutral glass tile
 * (UX-208). It used to be a house glyph, which looked exactly like the Home
 * nav icon right below it, so the frame showed two "Home" buttons.
 */
export function WorkspaceMark({ name, className }: { name: string | null | undefined; className?: string }) {
  const mark = workspaceMonogram(name)
  return (
    <span
      aria-hidden="true"
      className={cn(
        'shrink-0 inline-flex items-center justify-center rounded-[10px] bg-white/[0.06] border border-white/[0.10]',
        'text-[12px] font-semibold tracking-[0.02em] text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]',
        className,
      )}
    >
      {mark || <span className="block h-2 w-2 rounded-full bg-white/70" />}
    </span>
  )
}
